export const VerbatimField = {
  // These 2 namings are for backwards compatibility with existing fields
  Bhv_Improvement_RoleModel: 'Bhv_Improvement_RoleModel',
  Bhv_Improvement_SeeMore: 'Bhv_Improvement_SeeMore',
  Improvement_Strength: 'Improvement_Strength',
  Improvement_Development: 'Improvement_Development',
};
